import { useMemo } from 'react';
import { has, isPlainObject, isString } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { CloseRounded as CloseIcon } from '@mui/icons-material';
import { useEnvironment } from '@diana/core';
import { routeUrls } from '../../../app/Routing/RouteUrls';

export const CloseButton = () => {
  const environment = useEnvironment();
  const navigate = useNavigate();
  const location = useLocation();

  const canNavigateBackOnClose = useMemo(() => {
    if (isPlainObject(location.state)) {
      if (has(location.state, 'fromPathName')) {
        if (isString(location.state.fromPathName)) {
          const validPaths: string[] = [
            routeUrls.performance.path,
            routeUrls.performanceReport.path,
          ];
          return validPaths.some((validPath) => {
            const validPathAccessors = validPath.split('/');
            const prevPathAccessors = location.state.fromPathName.split('/');
            return validPathAccessors.every((accessor, index) => {
              if (accessor.startsWith(':') && isString(prevPathAccessors[index])) return true;
              return accessor === prevPathAccessors[index];
            });
          });
        }
      }
    }
    return false;
  }, [location]);

  const onClose = () => {
    if (canNavigateBackOnClose) navigate(-1);
    else navigate(routeUrls.performance.url({ environment }, null));
  };

  return (
    <IconButton data-testid="CloseButton" size="small" onClick={onClose}>
      <CloseIcon />
    </IconButton>
  );
};
